"use client";
import { Popconfirm, ButtonProps, Modal } from "@basic-components";
import { AuthButton } from "@general-components";
import { DeleteOutlined, ExclamationCircleOutlined } from "@ant-design/icons";
import { useToggle } from "@/hooks/useToggle";
interface DelActionButtonProps extends ButtonProps {
  text?: string;
  popTitle?: string;
  color?: "danger" | "orange" | "primary";
  onConfirm: () => void;
  isLoading: boolean;
  disabled?: boolean;
  authKey?: string;
  isIcon?: boolean;
  delType?: "modal" | "popconfirm";
}

export const DelActionButton = ({
  text = "删除",
  popTitle = "确认删除吗？",
  color = "danger",
  onConfirm,
  isLoading,
  disabled,
  authKey,
  isIcon = false,
  delType = "modal",
  ...restProps
}: DelActionButtonProps) => {
  const [visible, toggle] = useToggle();

  const handleOk = async () => {
    await onConfirm?.();
    toggle();
  };

  const handleClose = () => {
    toggle();
  };

  const triggerButton = (
    <AuthButton
      type="link"
      color={color}
      variant="link"
      disabled={isLoading || disabled}
      loading={isLoading}
      authKey={authKey}
      icon={
        isIcon ? (
          <DeleteOutlined style={{ fontSize: 16, color: "#ff4d4f" }} />
        ) : (
          restProps.icon
        )
      }
      onClick={delType === "modal" ? toggle : restProps.onClick}
      {...restProps}
    >
      {isIcon ? null : text}
    </AuthButton>
  );

  if (delType === "modal") {
    return (
      <>
        {triggerButton}
        <Modal
          width={416}
          closeIcon={false}
          title={
            <span className="flex gap-3">
              <ExclamationCircleOutlined
                style={{ color: "orange", fontSize: 20 }}
              />
              提示
            </span>
          }
          open={visible}
          onCancel={handleClose}
          onOk={handleOk}
        >
          {popTitle}
        </Modal>
      </>
    );
  }
  return (
    <Popconfirm
      title={popTitle}
      okText="确认"
      cancelText="取消"
      onConfirm={onConfirm}
    >
      {triggerButton}
    </Popconfirm>
  );
};
